import React, { useEffect } from "react";
import coloredNoiseImage from "@resources/images/colored-noise@2x.png";
import noiseImage from "@resources/images/noise@2x.png";

const Noise: React.FC = () => {
  useEffect(() => {
    const intervals: number[] = [];

    document
      .querySelectorAll<HTMLDivElement>("[data-noise]")
      .forEach((container) => {
        Array.from(container.children).forEach((noise, i) => {
          intervals[i] = window.setInterval(
            () => {
              const x = (Math.random() * 100).toFixed(5);
              const y = (Math.random() * 100).toFixed(5);

              const element = noise as HTMLDivElement;

              element.style.backgroundPosition = `${x}% ${y}%`;
            },
            Math.random() * 120 + 60,
          );
        });
      });

    return () => {
      intervals.forEach((interval) => window.clearInterval(interval));
    };
  }, []);

  return (
    <div
      className="hidden *:bg-repeat *:bg-[length:516px_auto] *:absolute *:inset-0 absolute *:mix-blend-overlay inset-0 z-40 pointer-events-none supports-[pointer-events:none]:block motion-reduce:hidden [mask-image:linear-gradient(to_bottom,transparent_0%,#000_100vh,#000_100%)]"
      data-noise
    >
      <div
        style={{
          backgroundImage: `url(${noiseImage})`,
          opacity: 0.02,
        }}
      />
      <div
        style={{
          backgroundImage: `url(${coloredNoiseImage})`,
          opacity: 0.02,
        }}
      />
    </div>
  );
};

export default Noise;
